import { ReactElement, Suspense, useEffect, useState } from 'react'

import QueryString from 'qs'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAsync } from 'react-use'

import LogoHorizontalWhite from '@shared/assets/images/logo-horizontal-white.svg'
import { FallbackNavigation } from '@shared/components/Fallback'
import { Text } from '@shared/components/Text'
import { Storage } from '@shared/constants/Storage'

import { useGetCurrentUser } from '@modules/users/hooks/useGetCurrentUser'

import { useAuth } from '../hooks/useAuth'

export const Auth = (): ReactElement => {
  const location = useLocation()
  const navigate = useNavigate()

  const [shouldGetCurrentUser, setShouldGetCurrentUser] = useState(false)

  const { signInByTokens, isAuthenticated } = useAuth()

  const { data: currentUser } = useGetCurrentUser({ isEnabled: shouldGetCurrentUser })

  const { accessToken, customToken, refreshToken } = QueryString.parse(location.search, { ignoreQueryPrefix: true })

  useAsync(async () => {
    if (accessToken && customToken && refreshToken) {
      await signInByTokens({
        accessToken: String(accessToken),
        customToken: String(customToken),
        refreshToken: String(refreshToken),
      })
    }
  }, [accessToken, customToken, refreshToken])

  // Enable to get current user
  useEffect(() => {
    if (isAuthenticated) {
      setShouldGetCurrentUser(true)
    }
  }, [isAuthenticated])

  // Save current user in local storage
  useEffect(() => {
    if (isAuthenticated && currentUser?.identifierId) {
      localStorage.setItem(Storage.CURRENT_PROFILE, JSON.stringify(currentUser))
      navigate('/', { replace: true })
    }
  }, [currentUser, isAuthenticated, navigate])

  return (
    <Suspense fallback={<FallbackNavigation />}>
      <main className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-[#0f172a] via-[#0c1a24] to-[#112f26]">
        <img src={LogoHorizontalWhite} alt="BrazaLink" className="mb-4 h-20 w-auto animate-pulse" />

        <Text className="font-body font-semibold text-white">
          Só mais um pouquinho, estamos personalizando o Braza do seu jeito!
        </Text>
      </main>
    </Suspense>
  )
}
